module.exports = __webpack_public_path__ + "img/flv.8907bae7.svg";